<template>
	<div class="h100" style="background-color: lightgray;">
        <div class="pt10 pl10 h100 w100" style="background-color: white;">
            <div class="flex" style="justify-content: space-between;">
                <div>消息中心</div>
                <div class="mr20">
                    <a-input-search 
                        size="small" 
                        allowClear 
                        v-model="search_key"
                        placeholder="请输入关键字" 
                        style="width: 188px; display: block;"
                        enter-button 
                        @search="goSearch" 
                        @pressEnter="goSearch"
                    />
                </div>
            </div>
            <div class="mt10 flex w100">
                <div>
                    <a-menu
                        style="width: 200px"
                        :default-selected-keys="['1']"
                        :open-keys.sync="openKeys"
                        mode="inline"
                        @click="handleClick"
                    >
                            <a-menu-item-group key="g1" title="待办">
                                <!-- <template slot="title"> <a-icon type="qq" /><span>待办</span> </template> -->
                                <a-menu-item key="1">
                                    全部待办
                                </a-menu-item>
                                <a-menu-item key="2" class="flex items-center">
                                    未处理
                                    <a-badge class="mb5" :count="unSettleCount">
                                    </a-badge>
                                </a-menu-item>
                                <a-menu-item key="3">
                                    已处理
                                </a-menu-item>
                            </a-menu-item-group>
                            <a-menu-item-group key="g2" title="通知">
                                <a-menu-item key="4">
                                    全部通知
                                </a-menu-item>
                                <a-menu-item key="5" class="flex items-center">
                                    未读通知
                                    <a-badge class="mb5" :count="unReadCount">
                                    </a-badge>
                                </a-menu-item>
                                <a-menu-item key="6">
                                    已读通知
                                </a-menu-item>
                            </a-menu-item-group>
                    </a-menu>
                    
                </div>
                <div class="w100 pd5" >
                    <div v-if="searchList.length > 0"  class="flex items-center mt10" style="flex-wrap:wrap">
                        <div class="fs12">
                            当前查询条件：
                        </div>
                        <div>
                            <a-tag v-for="item in searchList" :key="item.key" closable @close="deleteSearchItem(item)">
                                {{ (item.value.length>15)?((item.label + item.value.substring(0,15))+"..."):(item.label + item.value)  }}
                            </a-tag>
                        </div>
                        <a class="fs12 ml10" @click="clear">清空</a>

                    </div>
                    <div class="flex-height ml10 pd10" style="font-size:12px!important;">
                        <a-table :loading="loadingData" :data-source="clickData" :columns="clickColumns" size="small" bordered   :pagination="false">
                            <div
                                slot="filterDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px"
                            >
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-ant-ref="c => (searchInput = c)"
                                    :value="selectedKeys[0]"
                                    style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.field)"
                                />
                                <a-button
                                    type="primary"
                                    icon="search"
                                    size="small"
                                    style="width: 90px; margin-right: 8px"
                                    @click="() => handleSearch(selectedKeys, confirm, column.field)"
                                >
                                    确定
                                </a-button>
                                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                    清空条件
                                </a-button>
                            </div>
                            <div
                                slot="filterStatus"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px"
                            >
                                <div>
                                    <a-input
                                        size="small"
                                        placeholder="包含关键字"
                                        v-model="search_status"
                                        style="width: 188px; display: block;"
                                        @change="changeOptions"
                                        @pressEnter="handleSearch"
                                    />
                                    <a-checkbox :checked="checkAll" @change="onCheckAllChange">
                                        全选
                                    </a-checkbox>
                                    <a-checkbox-group
                                        v-model="checkedList"
                                        :options="plainOptions"
                                        @change="onChangeListStatus"
                                        class="flex-column"
                                    />  
                                    <!-- <a-checkbox-group
                                        v-model="selectedKeys[0]"
                                        :options="[{label: '审批中', value: 0},{label: '已通过', value: 1}]"
                                    /> -->
                                </div>
                                <div class="mt20">
                                    <a-button
                                        type="primary"
                                        icon="search"
                                        size="small"
                                        style="width: 90px; margin-right: 8px"
                                        @click="handleSearch"
                                    >
                                        确定
                                    </a-button>
                                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                        清空条件
                                    </a-button>
                                </div>
                            </div>
                            <template slot="type" slot-scope="row">
                                <div class="one-line">
                                    <div>{{ row.type }}</div>
                                </div>
                            </template>
                            <template slot="title" slot-scope="row">
                                <div class="one-line">
                                    <a @click="goDetail(row)">{{ row.title }}</a>
                                </div>
                            </template>
                            <template slot="create_person" slot-scope="row">
                                <div class="one-line">
                                    <div>{{ row.create_person }}</div>
                                </div>
                            </template>
                            <template slot="detail" slot-scope="row">
                                <div class="one-line">
                                    <div>{{ row.detail }}</div>
                                </div>
                            </template>
                            <template slot="create_time" slot-scope="row">
                                <div class="one-line">
                                    <div>{{ row.create_time }}</div>
                                </div>
                            </template>
                            <template slot="status" slot-scope="row">
                            <div class="flex">
                                <div v-if="parseInt(select_item_key)<4">
                                    <span v-if="row.status == 0" style="color:orange;">待处理</span>
                                    <span v-else-if="row.status == 1" style="color:green;">已处理</span>
                                </div>
                                <div v-else>
                                    <span v-if="row.status == 0" style="color:orange;">未读</span>
                                    <span v-else-if="row.status == 1" style="color:green;">已读</span>
                                </div>
                            </div>
                        </template>
                        </a-table>
                        <a-pagination class="mt10 text-right" size="small" @change="onChangePage" v-model="pagination.page" :total="pagination.total" :defaultPageSize="pagination.page_len" />
                    </div>

                </div>
            </div>
        </div>
	</div>
  </template>
  
  <script>
 import { EventBus } from '@/main';
  export default {
	components: {

	},
	data () {
	  	return {
			columns1:[
				{
                    title: '消息类型',
                    key: 'type',
                    field: 'aa.type', 
                    width:150,
                    scopedSlots: { customRender: 'type', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                    customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
				{
                    title: '消息主题',
                    key: 'title',
                    field: 'aa.title', 
                    scopedSlots: {   customRender: 'title', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
				// {
                //     title: '消息内容',
                //     key: 'detail',
                //     field: 'a.name', 
                //     scopedSlots: {   customRender: 'detail', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                //      customFilterDropdown: true,
                //     onFilter: (value, record) => {},
                //     onFilterDropdownVisibleChange: visible => {},
                //     sorter: (a, b) => a.name.length - b.name.length,
				// },
                // {
                //     title: '关联数据',
                //     key: 'data',
                //     field: 'a.name', 
                //     scopedSlots: {   customRender: 'data', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                //      customFilterDropdown: true,
                //     onFilter: (value, record) => {},
                //     onFilterDropdownVisibleChange: visible => {},
                //     sorter: (a, b) => a.name.length - b.name.length,
				// },
                {
                    title: '提交人',
                    key: 'create_person',
                    field: 'aa.create_person', 
                    width:150,
                    scopedSlots: {   customRender: 'create_person', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
                {
                    title: '创建时间',
                    key: 'create_time',
                    field: 'aa.create_time', 
                    width:250,
                    scopedSlots: {   customRender: 'create_time', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
				{
                    title: '状态',
                    key: 'status',
                    field: 'status', 
                    width:100,
                    scopedSlots: {   customRender: 'status', filterDropdown: 'filterStatus', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
				},
			],
            columns2:[
				{
                    title: '消息类型',
                    key: 'type',
                    field: 'aa.type', 
                    scopedSlots: {   customRender: 'type', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
                {
                    title: '消息主题',
                    key: 'title',
                    field: 'aa.title', 
                    scopedSlots: {   customRender: 'title', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
                {
                    title: '消息内容',
                    key: 'detail',
                    field: 'aa.detail', 
                    scopedSlots: {   customRender: 'detail', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
                {
                    title: '创建时间',
                    key: 'create_time',
                    field: 'aa.create_time', 
                    width:250,
                    scopedSlots: {   customRender: 'create_time', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
                    sorter: (a, b) => a.name.length - b.name.length,
				},
				{
                    title: '状态',
                    key: 'status',
                    field: 'status', 
                    width:100,
                    scopedSlots: {   customRender: 'status', filterDropdown: 'filterStatus', filterIcon: 'filterIcon'}, 
                     customFilterDropdown: true,
                    onFilter: (value, record) => {},
                    onFilterDropdownVisibleChange: visible => {},
				},
			],
            clickColumns:[],
			clickData:[],
            current: ['mail'],
            openKeys: ['sub1'],
            loadingData:false,
            pagination: {
                page: 1,
                page_len: 10,
                total: 1
            },
            search_field:[],
            searchList:[],
            tableHeight:"",
            select_item_key:"1",
            search_key:"",
            checkAll:false,
            checkedList:[],
            standardOption1:[{label: '待处理', value: 0},{label: '已处理', value: 1}],
            standardOption2:[{label: '未读', value: 0},{label: '已读', value: 1}],
            plainOptions:[{label: '待处理', value: 0},{label: '已处理', value: 1}],
            search_status:"",
            unReadCount:0,
            unSettleCount:0,
            oaTypeList:[{id:1, name:"补卡"},{id:2, name:"请假"},{id:3, name:"加班"},{id:4, name:"出差"},{id:5, name:"报销"},{id:15, name:"外勤"},{id:16, name:"销假"},{id:22, name:"请假"},{id:23, name:"请假"},{id:24, name:"出差"},{id:25, name:"出差"},]

	  	}
	},
    watch: {
        openKeys(val) {
            console.log('openKeys', val);
        },
    },
	computed: {
       
	},
	created () {
        this.clickColumns = this.columns1
        this.getPendingAndDoneApply()
        this.getUnsettleAndUnReadCount()
	},
	mounted () {
	 
	},
	methods: {
        async getPendingAndDoneApply(){
            this.loadingData = true;
            let field = JSON.stringify(this.search_field)
            let intlist = JSON.stringify(this.checkedList)
            
            let rs = await this.$api.getPendingAndDoneApply(this.select_item_key, this.search_key, field, intlist, this.pagination.page - 1, this.pagination.page_len)
            this.loadingData = false;
            if (rs.err == 0) {
                let ca = ((this.pagination.page - 1) * this.pagination.page_len) + 1
                for (let item of rs.data.list) {
                    if(item.contract_type_id == 1&&item.type_id == 1){
                        item.type = "进项合同"
                    }else if(item.contract_type_id == 2&&item.type_id == 2){
                        item.type = "甲方合同"
                    }else if(item.type_id == 6){
                        // item.title = item.type_project_name
                        item.title = item.type
                    }else if(item.type_id == 104){
                        item.title = "撤销申请"
                    }
                    item.key = ca
                    let s = item.create_time;
                    item.create_time = new Date(s[0], s[1]-1, s[2], s[3], s[4], (s[5])?s[5]:0).Format("yyyy-MM-dd hh:mm:ss");
                    // item.status = (item.status == 0)?"待处理":"已处理";
                    ca ++;
                    // let s = item.create_time;
                    // item.create_time = `${s[0]}-${s[1]}-${s[2]} ${s[3]}:${s[4]}:${s[5]}`
                }
                this.clickData = rs.data.list
                this.pagination.total = rs.data.total
            }

        },
        async getUnsettleAndUnReadCount(){
            let rs = await this.$api.getUnsettleAndUnReadCount()
            if (rs.err == 0) {
                this.unSettleCount = rs.data.o_unSettle_count
                this.unReadCount = rs.data.o_unRead_count
            }
        },
        async handleSearch(selectedKeys, confirm, dataIndex) {
            if(this.checkedList.length != 0){
                let status_name = ""
                for(let c1 of this.checkedList){
                    let n1 = (c1 == 0)?"待处理":"已处理"
                    status_name = (status_name.length == 0)?n1:status_name + "、" + n1
                }
                let item = this.searchList.find(it=>it.field == "a.status")
                if(item == null){
                    this.searchList.push({key:this.searchList.length, field:"a.status", label: "状态:", value:status_name})
                }else{
                    item.value = status_name
                }
            }
            if (selectedKeys.length > 0 && selectedKeys[0] != null && selectedKeys[0] != "") {
                let value = selectedKeys[0];
                if (dataIndex == "a.status") {
                    if (selectedKeys[0].length == 1) {
                        value = selectedKeys[0][0];
                    } else {
                        // this.getContracts();
                        return;
                    }
                }
                this.mode = 1;
                let item = this.search_field.find(it=>it.field == dataIndex)
                if(item != null){
                    item.value = value
                }else{
                    this.search_field.push({key:this.search_field.length, field:dataIndex, value:value})
                }
                let item2 = this.searchList.find(it=>it.field == dataIndex)
                if(item2 != null){
                    item2.value = value
                }else{
                    let part = this.clickColumns.find(it=>it.field == dataIndex)
                    if(part != null){
                        this.searchList.push({key:this.searchList.length, field:dataIndex, label: (part.title + ":"), value:value})
                    }
                }
                this.pagination.page = 1;
                this.goSearch()
            }
        },
        handleReset(clearFilters) {
            clearFilters();
            this.search_field = []
            this.searchList = []
            this.search_key = ""
            this.checkedList = []
            this.pagination.page = 1
          
            this.goSearch()
        },
        handleClick(e) {
            this.search_field = []
            this.searchList = []
            this.search_key = ""
            this.checkedList = []
            this.pagination.page = 1
            this.select_item_key = e.key
            if(parseInt(e.key) <= 3){
                this.clickColumns = this.columns1
                this.plainOptions = this.standardOption1
            }else{
                this.clickColumns = this.columns2
                this.plainOptions = this.standardOption2

            }
            this.goSearch()
            // this.pagination.page = 1
            // let a1 = parseInt(select_item_key)
            // let a2 = parseInt(e.key)
            // if(((a1>=1)&&(a1<= 3)&&(a2>3))||((a1>=4)&&(a1<= 6)&&(a2<4)){
            //     this.search_field = []
            //     this.searchList = []
            //     this.search_key = ""
            //     this.checkedList = []
            // }
            // this.select_item_key = e.key
        
        },
        titleClick(e) {
            console.log('titleClick', e);
        },
        onChangePage(){
            // console.log(this.pagination.page)
            // if(parseInt(this.select_item_key) <= 3){
                this.getPendingAndDoneApply()
            // }
        },
        deleteSearchItem(item){
            this.searchList = this.searchList.filter(it=>it.field != item.field)
            this.search_field = this.search_field.filter(it=>it.field != item.field)
            if(item.field == "a.create_time"){
                this.search_time_from = undefined
                this.search_time_to = undefined
            }
            if(item.field == "a.status"){
               this.checkedList = []
            }
            if(item.field == "a.project_list"){
                this.ProjectCheckedList = []
            }
            this.pagination.page = 1;
            this.getPendingAndDoneApply()
        },
        clear(){
            this.search_field = []
            this.searchList = []
            this.search_key = ""
            this.checkedList = []
            this.pagination.page = 1
            this.getPendingAndDoneApply()
        },
        goSearch(){
            // if(parseInt(this.select_item_key) <= 3){
                this.getPendingAndDoneApply()
            // }else{

            // }
        },
        changeOptions(){
            let number = parseInt(this.select_item_key)
            if(this.search_status.length != 0){
                if(number <= 3){
                    this.plainOptions = this.standardOption1.filter(it=>(it.label.indexOf(this.search_status))>= 0)
                }else{
                    this.plainOptions = this.standardOption2.filter(it=>(it.label.indexOf(this.search_status))>= 0)
                }
            }else{
                if(number <= 3){
                    this.plainOptions = this.standardOption1
                }else{
                    this.plainOptions = this.standardOption2
                }
            }
        },
        onChangeListStatus(checkedValues) {
            if(this.checkedList.length == this.plainOptions.length){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        onCheckAllChange(e) {
            if(e.target.checked){
                this.checkAll = true
                this.checkedList = this.plainOptions.map(it=> it.value)
            }else{
                this.checkAll = false
                this.checkedList = []
            }
        },
        goDetail(row){
            // console.log(row)
            // return;
            // console.log(row.contract_type_id)
            // console.log(row.type_id)
            if(parseInt(this.select_item_key) == 5){
                this.changeReadStatus(row.id)
                EventBus.$emit('data-updated', "");
            }
            if(row.contract_type_id == 1 && row.type_id ==3){
				this.$router.push(`/contract/contract?contract_id=${row.detail_id}`)
            }else if(row.contract_type_id == 0){
                if((row.type_id == 4)&&(row.type.length == 4)){
                    this.$router.push(`/stamp?stamp_id=${row.detail_id}`)
                }else if(row.type_id == 104){
                    this.$router.push(`/stamp?cancel_id=${row.detail_id}`)
                }else if(row.type_id == 10){
                    this.$router.push(`/hr/requirement?detail_id=${row.detail_id}`)
                } else{
                    if([1,2,3,4,15, 16, 17, 22,23,24,25].includes(row.type_id)){
                        this.$router.push(`/personnel/attendance/apply?detail_id=${row.detail_id}`)
                    }else if (row.type_id == 19){
                        this.$router.push(`/projectManage/scheme_approval?detail_id=${row.detail_id}`)
                    }else if (row.type_id == 31){
                        this.$router.push(`/purchase/scrap_sale?detail_id=${row.detail_id}`)
                    }else if (row.type_id == 34){
                        this.$router.push(`/purchase/add?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 12){
                        this.$router.push(`/hr/dimission?detail_id=${row.detail_id}`)
                    }else if (row.type_id == 5){
                        this.$router.push(`/finance/reimburse?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 6){
                        this.$router.push(`/finance/applypay?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 49){
                        this.$router.push(`/projectManage/machine?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 50){
                        this.$router.push(`/projectManage/employing?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 18){
                        this.$router.push(`hr/hire?detail_id=${row.detail_id}`)
                    }else if(row.type_id == 40){
                        this.$router.push(`/serve_fee?detail_id=${row.detail_id}`)
                    }
                    
                } 
            }else if(row.contract_type_id == 2 && row.type_id ==3){
                this.$router.push(`/contract/clients?contract_id=${row.detail_id}`)
            }
            // else if(row.contract_type_id == 40){
            //     this.$router.push(`/serve_fee?detail_id=${row.detail_id}`)
            // }
            else if(row.contract_type_id == 27){
                this.$router.push(`/purchase/bidding?detail_id=${row.detail_id}`)
            }else{
                this.$router.push(`/personnel/attendance/apply?detail_id=${row.detail_id}`)
            }

        },
        async changeReadStatus(key){
            let rs = await this.$api.changeReadStatus(key)
            if(rs.err == 0){
                this.getPendingAndDoneApply()
                this.getUnsettleAndUnReadCount()
            }
        },

	}
  }
  </script>
  
  <style lang="scss" scoped>
  .flow-item {
      cursor: pointer;
      border: 1px solid rgba(0,0,0,0.1);
      padding: 5px 5px 5px 5px;
      font-size: 12px;
  }
  .select-flow-item {
      cursor: pointer;
      position: relative;
      .item {
          border-bottom: 1px solid rgba(0,0,0,0.1);
          padding: 5px 5px 5px 5px;
          font-size: 12px;
      }
  }
  .select-flow-item:not(:last-child):after {
      content: "";
      position: absolute;
      right: -10px;
      top: 23px;
      height: 2px;
      width: 10px;
      background: #d8d8d8;
  }
  .user_group {
      list-style-type: none;
      margin: 0;
      padding-left: 20px;
      padding-top: 10px;
  
      li {
          height: 30px;
          border: 1px solid rgba(0,0,0,0.05);
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          cursor: pointer;
  
          &.active {
              background: #67C23A;
              color: white;
          }
      }
  }
  </style>
  
  <style scoped>
  /deep/.ant-table {
      font-size: 13px!important;
  }
  /deep/.ant-table-thead > tr > th {
      font-size: 14px!important;
  }
  
  
  </style>
  
  <style lang="scss" scoped>
  .m-attachment {
      padding: 5px;
      transition: all 0.3s;
      .m-close {
          opacity: 0;
          transition: all 0.3s;
      }
  }
  .m-attachment:hover {
      background-color: #f5f5f5;
      transition: all 0.3s;
      .m-close {
          opacity: 1;
          transition: all 0.3s;
      }
  }
  </style>
  
  <style scoped>
  /deep/.ant-table-thead {
      background: #f0f2f5;
  }
  /deep/.ant-drawer-content {
      overflow: visible;
  }
  /deep/.ant-form-item {
      margin-bottom: 13px!important;
  }
  /deep/.ant-table {
      font-size: 13px!important;
  }
  </style>
  